export default function formatCurrency(amount) {
  if (amount == null || isNaN(amount)) return "₦ 0";
  return `₦ ${Number(amount).toLocaleString()}`;
}
